import React, { useContext, useEffect, useState } from "react"
import IconCircle from "./icon-circle"
import { Link } from "gatsby"
import ChangeQuantity from "../hooks/changeQuantity"
import QuantityControl from "./quantity-control"
import { RootContext } from "../context/beltContext"
import AddToCartToast from "./add-to-cart-toast"
import { navigate } from "@reach/router" 
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import UseWindowSize from "./use-window-size";

const BeltSubscriptionCard = ({ belt, updateBelts, loggedIn, permission, loginWithRedirect, wrap, hideIcon }) => {
    let { quantity, addToCart, updateSku } = ChangeQuantity(belt.sku, false)
    let [formattedTotal, setTotal] = useState('$0.00')
    let { skus } = useContext(RootContext)
    let [showToast, setShowToast] = useState(false)
    let screenSize = UseWindowSize()
    let ulRow = 'row'

    if (screenSize.width < 576) {
        ulRow = ''
    }
    else {
        ulRow = 'row'
    }

    useEffect(() => {
        updateSku(belt.sku)
    }, [quantity, skus, belt.sku, updateSku])

    useEffect(() => { }, [permission])

    useEffect(() => {
        if (typeof belt.sku === undefined) return;
        let cart = typeof window !== undefined && window.localStorage.getItem('cart');
        cart = JSON.parse(cart);
        if (!!cart && cart[belt.sku]) {
            setTotal(cart[belt.sku].formattedTotal)
        }
        updateSku(belt.sku)
    }, [belt.sku, updateSku])

    let specificColor = ''
    let specificHexes = []
    let specificIconHex = ''

    if (belt.color !== undefined) {
        specificColor = belt.color
    } else {
        specificColor = 'blue'
        specificHexes = ['#efc621', '#1ECA8A', '#7C8BDF', '#00aeef', '#d27a7b']
        specificIconHex = '#00aeef'
    }

    const add = () => {
        addToCart(belt.sku, belt.title, setShowToast)
    }

    const mainIconAndTitle = 
        <div>
            { hideIcon ? <></> :
                <div className={`text-${specificColor} d-flex mb-3`} style={{maxHeight:'5rem'}}>
                    <IconCircle
                        size={'5rem'}
                        color={ specificColor === belt.color ? belt.hex : specificIconHex }
                        icon={belt.icon}
                        additionalClass={'mx-auto'}
                    />
                </div>
            }
            <p className={`text-${specificColor} font-lg text-uppercase text-center mb-2`}>
                {
                    typeof belt.title === 'string' ?
                        belt.title
                    :
                        belt.title.map((object, key) => { return <React.Fragment key={key}>{object}</React.Fragment> })
                }
            </p>
        </div>

    return (
        <div className={wrap ? `col-lg-6` : `col-lg-3 col-sm-6`}>
            <div className='card h-100'>
                <div className='card-body d-flex flex-column'>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id={`${belt.sku}-tooltip`}>{belt.description}</Tooltip>
                        }
                    >   
                        { mainIconAndTitle }
                    </OverlayTrigger>
                    
                    <p className='text-muted font-md text-center'>
                        {(belt.makePricePublic || permission) && !belt.contactUs ?
                            belt.listPrice
                            :
                            belt.contactUs ?
                            'Contact for pricing' :
                            'Sign in to see pricing'
                        }
                    </p>
                    <ul className={wrap ? `ps-0 mx-auto justify-content-center ${ulRow}` : `ps-0 mx-auto`} style={{ maxWidth: 'fit-content' }}>
                        {
                            belt.tools.map((tool, i) => {
                                return (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`${belt.tools[i]}-tooltip`}>{belt.tooltips[i]}</Tooltip>
                                        }
                                        key={i}
                                    >   
                                        <li 
                                            className={ wrap ? `text-${specificColor} d-flex mb-4 col-sm-6` : `text-${specificColor} d-flex mb-4` } 
                                            style={ specificColor === belt.color ? {} : { color: specificHexes[i] } } 
                                            key={i}
                                        >
                                            <IconCircle
                                                size={'3rem'}
                                                color={specificColor === belt.color ? belt.hex : specificHexes[i]}
                                                icon={belt.toolIcons[i]}
                                                additionalClass={'me-3'}
                                            />
                                            <p className={`my-auto`}>
                                                {tool}
                                            </p>
                                        </li>
                                    </OverlayTrigger>   
                                )
                            })
                        }
                    </ul>
                    {(belt.makePricePublic || permission) && !belt.contactUs ?
                        <div className='d-flex flex-column mb-0 mt-auto'>
                            <QuantityControl sku={belt.sku} callback={setTotal} />
                            <div className='d-flex text-muted mt-4'>
                                <div className='mx-auto'>Total</div>
                                <div className='mx-auto'>{formattedTotal}</div>
                            </div>
                            <button className='btn btn-yellow mx-auto mt-4' onClick={add}>Add to Cart</button>
                            <Link to={'/cart'} className='mx-auto mt-4'><button className='btn btn-primary'>Go to Cart</button></Link>
                        </div>
                        :
                        belt.contactUs ? 
                        <div className='d-flex mb-0 mt-auto'>
                            <button className='btn btn-yellow mx-auto' onClick={() => navigate('/contact-us')}>Contact Us</button>
                        </div>
                        :
                        <div className='d-flex mb-0 mt-auto'>
                            <button className='btn btn-yellow mx-auto' onClick={() => loginWithRedirect()}>Sign in to Order Now</button>
                        </div>
                    }
                </div>
            </div>
            <AddToCartToast show={showToast} toggle={() => setShowToast(!showToast)}/>
        </div>
    )


}

export default BeltSubscriptionCard;